import { useQuery } from 'react-query'
import { getStates } from 'services/states'

export const useStates = () => {
  const states = useQuery('states', getStates, { retry: false, refetchIntervalInBackground: false, refetchOnWindowFocus: false })
  return states
}
